import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

// Wherever CSS truncates text with "…", hovering shows the full text (QA 2026-09-30).
// ponytail: one global listener instead of a tooltip per field; covers tables, selects, stat tiles.
document.addEventListener('mouseover', (e) => {
  let el = e.target as HTMLElement | null;
  for (let i = 0; el && i < 3; i++, el = el.parentElement) {
    if (el.title || el.scrollWidth <= el.clientWidth) continue;
    if (getComputedStyle(el).textOverflow === 'ellipsis') { el.title = el.innerText.trim(); return; }
  }
});
